export const returnSub = (Id, charNumber) => {
  const id_Tail = (Id + '').length
  const toStr = Id + ''

  try {
    return toStr.substring(id_Tail, id_Tail - charNumber)
  } catch (error) {
    console.log(error)
  }
}

export const checkFiles = (name) => {
  const extension = name.split('.').pop()
  const ext = ['pdf', 'png', 'jpg', 'jpeg']
  const res = ext.find((item) => item === extension)
  if (
    res &&
    res.includes('png') |
      res.includes('pdf') |
      res.includes('jpeg') |
      res.includes('jpg')
  ) {
    return true
  } else {
    console.log('not match')
  }
}

export const checkValue = (...data) => {
  const { name, tel, old, town, skill } = data
  try {
    if (typeof old !== 'number') {
      alert("L'age doit etre en chiffre.")
      return
    }
  } catch (error) {}
}
